export default {"src":"/_next/static/media/saipos.bb2465f2.svg","height":73,"width":300,"blurWidth":0,"blurHeight":0};